import appendQuery from 'append-query'
import { request, ANALYTICS_URL, WEB_API_KEY } from '../../api'

type ContentType = 'GIFs & Stickers' | 'GIFs' | 'Stickers' | 'Stories' | 'Clips' | string

export const getDashboard = (contentType: ContentType, dateRange: [Date, Date], username: string) => {
    const contentTypes: Record<ContentType, string> = {
        'GIFs & Stickers': 'gif,sticker,emoji,genie,text',
        GIFs: 'gif',
        Stickers: 'sticker,emoji,genie,text',
        Stories: 'story',
        Clips: 'clip',
    }

    const formatDate = (inputDate: Date) => {
        const dd = String(inputDate.getDate()).padStart(2, '0')
        const mm = String(inputDate.getMonth() + 1).padStart(2, '0') // January is 0!
        const yyyy = inputDate.getFullYear()
        return `${yyyy}-${mm}-${dd}`
    }

    const startDate = formatDate(dateRange[0])
    const endDate = formatDate(dateRange[1])

    const url = appendQuery(`${ANALYTICS_URL}dashboard/`, {
        api_key: WEB_API_KEY,
        start_dt: startDate,
        end_dt: endDate,
        content_type: contentTypes[contentType] || contentTypes['GIFs & Stickers'],
        username,
    })

    return request(url)
}
